import React from 'react';
import 'bootstrap/dist/css/bootstrap.css'
import "../../assets/scss/style.scss"
import Contact from '../contact'
import Brand from '../brands'
import Footer from '../footer'
import CopyRight from '../copyright_text'
import Navbar from '../navbar'

function Layout({ children }) {
    return (
        <div className="main-wrapper">
            <Navbar />
            <div id="main-content">
                {children}
                <Contact />
                <Brand />
                <Footer />
                <CopyRight />
            </div>
        </div>
    );
}

export default Layout;